import { useCallback } from 'react'
import { useQuery, useCommand } from './cqrpc'

export function useCurrentUser(){
  const { result: currentUser, loading, error, mutate } = useQuery('sessions.getCurrentUser')
  const reload = useCallback(() => mutate(), [mutate])
  return { currentUser, loading, error, mutate, reload }
}

export function useLogout(options = {}){
  const { reload } = useCurrentUser()
  return useCommand('users.logout', {
    ...options,
    onSuccess(){
      reload()
      if (options.onSuccess) options.onSuccess()
    },
  })
}
